import {
  getHygieneCheck,
  getPoints,
  getTargetVsAchievement,
} from '@api/dashboard';
import { fetchLeadsData } from '@api/leads';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardState } from '@utils/types';

export const getDashboardData = createAsyncThunk(
  'getDashboardData',
  async (_, thunkAPI) => {
    try {
      const result = await Promise.allSettled([
        getTargetVsAchievement(),
        fetchLeadsData(null),
        getPoints(),
        getHygieneCheck(),
      ]);

      const targetAchievement = result[0]?.value;
      const leads = result[1]?.value;
      const points = result[2]?.value;
      const hygieneCheck = result[3]?.value;

      const leadsChartObject = {
        login: 0,
        wip: 0,
        noRejectPolicy: 0,
        abnd: 0,
        disbursed: 0,
        expired: 0,
      };

      leads.lead_data.forEach((lead: any) => {
        switch (lead.lead_data.lead_description.toLowerCase()) {
          case 'login':
            leadsChartObject.login += 1;
            break;
          case 'wip':
            leadsChartObject.wip += 1;
            break;
          case 'reject':
            leadsChartObject.noRejectPolicy += 1;
            break;
          case 'abnd':
            leadsChartObject.abnd += 1;
            break;
          case 'disbursed':
            leadsChartObject.disbursed += 1;
            break;
          case 'expired':
            leadsChartObject.expired += 1;
            break;

          default:
            break;
        }
      });
      return {
        targetAchievement: {
          target: targetAchievement.target ?? 0,
          achievement: targetAchievement.achievement ?? 0,
        },
        leadsChartObject,
        totalLeads: leads?.lead_data_count ?? 0,
        points: points?.points ?? 0,
        rc: {
          percentage: parseFloat(
            hygieneCheck.trade_data[0]?.rc_percentage ?? 0,
          ),
          count: parseInt(hygieneCheck.trade_data[0]?.rc_count ?? 0),
        },
        delinquency: hygieneCheck.trade_data[0].delinquency ?? '0%',
        tradeAdvance: {
          preApprovedLimit: hygieneCheck.trade_data[0].pre_approved_limit ?? 0,
          availed: hygieneCheck.trade_data[0].ta_availed ?? 0,
        },
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const initialState: DashboardState = {
  targetAchievement: {},
  leadsChartObject: {
    login: 0,
    wip: 0,
    noRejectPolicy: 0,
    abnd: 0,
    disbursed: 0,
    expired: 0,
  },
  totalLeads: 0,
  rc: { percentage: 0, count: 0 },
  delinquency: '0%',
  tradeAdvance: {
    preApprovedLimit: 0,
    availed: 0,
  },
  error: false,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getDashboardData.fulfilled,
      (state: DashboardState, action: PayloadAction<DashboardState>) => {
        state.targetAchievement = action.payload.targetAchievement;
        state.leadsChartObject = action.payload.leadsChartObject;
        state.totalLeads = action.payload.totalLeads;
        state.points = action.payload.points;
        state.rc = action.payload.rc;
        state.delinquency = action.payload.delinquency;
        state.tradeAdvance = action.payload.tradeAdvance;
        state.error = false;
      },
    );
    builder.addCase(getDashboardData.rejected, (state: DashboardState) => {
      state.error = true;
    });
  },
});

export default dashboardSlice.reducer;
